import _ from 'lodash';


//find index for the given array.
 export default function (array, path) {  
  let indexKnow = 0;
  array.forEach((e,index)=>{
   if(e.path===path){
     indexKnow=index
   }
  })
  return indexKnow

}